import { render, staticRenderFns } from "./_t.vue?vue&type=template&id=2038bd3a&"
import script from "./_t.vue?vue&type=script&lang=js&"
export * from "./_t.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "_t.vue"
export default component.exports